import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    startLocalVideo: false,
    startLocalAudio: false,
    isAnyVideoAvailableInTheRoom: false,
    streamingPartiIdentity: null,
    streamingDetails: {},
    participantName: "",
    localUserNetworkQuality: null,
    remoteUserNetworkQuality: null,
    participantIdentities: [],
    notAllowedCamera: false,
    allowedMicrophone: false,
    videoError: {},
    audioErrorModal: false,
    audioError: {},
    allAudioTrackIdentity: [],
    isLocalUserScreenSharing: false,
    isScreenShareInfoOpen: false,
    isScreenShareMirrorWarningOpen: false,
    isScreenShareMirrorWarningIgnored: false,
    isOpponentUserScreenSharing: false,
    isConfirmScreenShareModalOpen: false,
    screenShareErrorOccurredFor: false,
    screenShareUnsupportedMsg: "",
    videoStreamingUsers: [],
    screenSharingUsers: [],
    isConfirmVideoModalOpen: false,
    showiOSAudioMsg: false,
    disconnectedUsersList: [],
    dataTrack: null,
    isAudioTrackAttchedForAnyParticipant: false,
    showPopupForPlayAudio: false,
    screenshareIdentityParticipantVise: [],
    videoIdentityParticipantVise: [],
    allUserAudioStatus: {},
    isLocalVideoAttached: false,
};

const twilioEventsReducerSlice = createSlice({
    name: "twilioEventsReducer",
    initialState,
    reducers: {
        setStartLocalVideo(state, action) {
            state.startLocalVideo = action.payload;
        },
        setStartLocalAudio(state, action) {
            state.startLocalAudio = action.payload;
        },
        setIsAnyVideoAvailableInTheRoom(state, action) {
            state.isAnyVideoAvailableInTheRoom = action.payload;
        },
        setParticipantName(state, action) {
            state.participantName = action.payload;
        },
        setLocalUserNetworkQuality(state, action) {
            state.localUserNetworkQuality = action.payload;
        },
        setRemoteUserNetworkQuality(state, action) {
            state.remoteUserNetworkQuality = action.payload;
        },
        setStreamingPartiIdentity(state, action) {
            state.streamingPartiIdentity = action.payload;
        },
        setStreamingDetails(state, action) {
            state.streamingDetails = action.payload;
        },
        setParticipantIdentities(state, action) {
            state.participantIdentities = action.payload;
        },
        setNotAllowedCamera(state, action) {
            state.notAllowedCamera = action.payload;
        },
        setAllowedMicrophone(state, action) {
            state.allowedMicrophone = action.payload;
        },
        setVideoError(state, action) {
            state.videoError = action.payload;
        },
        setAudioErrorModal(state, action) {
            state.audioErrorModal = action.payload;
        },
        setAudioError(state, action) {
            state.audioError = action.payload;
        },
        setAllAudioTrackIdentity(state, action) {
            state.allAudioTrackIdentity = action.payload;
        },
        setIsLocalUserScreenSharing(state, action) {
            state.isLocalUserScreenSharing = action.payload;
        },
        setIsScreenShareInfoOpen(state, action) {
            state.isScreenShareInfoOpen = action.payload;
        },
        setIsScreenShareMirrorWarningOpen(state, action) {
            state.isScreenShareMirrorWarningOpen = action.payload;
        },
        setIsScreenShareMirrorWarningIgnored(state, action) {
            state.isScreenShareMirrorWarningIgnored = action.payload;
        },
        setIsOpponentUserScreenSharing(state, action) {
            state.isOpponentUserScreenSharing = action.payload;
        },
        setVideoStreamingUsers(state, action) {
            state.videoStreamingUsers = action.payload;
        },
        setScreenSharingUsers(state, action) {
            state.screenSharingUsers = action.payload;
        },
        setIsConfirmScreenShareModalOpen(state, action) {
            state.isConfirmScreenShareModalOpen = action.payload;
        },
        setScreenShareErrorOccurredFor(state, action) {
            state.screenShareErrorOccurredFor = action.payload;
        },
        setScreenShareUnsupportedMsg(state, action) {
            state.screenShareUnsupportedMsg = action.payload;
        },
        setIsConfirmVideoModalOpen(state, action) {
            state.isConfirmVideoModalOpen = action.payload;
        },
        setShowiOSAudioMsg(state, action) {
            state.showiOSAudioMsg = action.payload;
        },
        addDisconnectedUser(state, action) {
            state.disconnectedUsersList.push(action.payload);
        },
        setDataTrack(state, action) {
            state.dataTrack = action.payload;
        },
        setIsAudioTrackAttchedForAnyParticipant(state, action) {
            state.isAudioTrackAttchedForAnyParticipant = action.payload;
        },
        setShowPopupForPlayAudio(state, action) {
            state.showPopupForPlayAudio = action.payload;
        },
        setScreenshareIdentityParticipantVise(state, action) {
            state.screenshareIdentityParticipantVise = action.payload;
        },
        setVideoIdentityParticipantVise(state, action) {
            state.videoIdentityParticipantVise = action.payload;
        },
        setAllUserAudioStatus(state, action) {
            state.allUserAudioStatus = action.payload;
        },
        setIsLocalVideoAttached(state, action) {
            state.isLocalVideoAttached = action.payload;
        },
        resetTwilioEventsReducer() {
            return initialState;
        },
    },
});

export const {
    setStartLocalVideo,
    setStartLocalAudio,
    setIsAnyVideoAvailableInTheRoom,
    setParticipantName,
    setLocalUserNetworkQuality,
    setRemoteUserNetworkQuality,
    setStreamingPartiIdentity,
    setStreamingDetails,
    setParticipantIdentities,
    resetTwilioEventsReducer,
    setNotAllowedCamera,
    setAllowedMicrophone,
    setAudioErrorModal,
    setAudioError,
    setAllAudioTrackIdentity,
    setVideoError,
    setIsLocalUserScreenSharing,
    setIsScreenShareInfoOpen,
    setIsScreenShareMirrorWarningOpen,
    setIsOpponentUserScreenSharing,
    setIsScreenShareMirrorWarningIgnored,
    setVideoStreamingUsers,
    setScreenSharingUsers,
    setIsConfirmScreenShareModalOpen,
    setScreenShareErrorOccurredFor,
    setScreenShareUnsupportedMsg,
    setIsConfirmVideoModalOpen,
    setShowiOSAudioMsg,
    addDisconnectedUser,
    setDataTrack,
    setIsAudioTrackAttchedForAnyParticipant,
    setShowPopupForPlayAudio,
    setScreenshareIdentityParticipantVise,
    setVideoIdentityParticipantVise,
    setAllUserAudioStatus,
    setIsLocalVideoAttached,
} = twilioEventsReducerSlice.actions;
export default twilioEventsReducerSlice.reducer;
